import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames, isBrowser } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmPin } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import { Cta } from '../../components/Cta/cta.js';

const Event = props => {
  const {
    item
  } = props;
  const label = useLabel();
  const {
    decorateUrl
  } = useLlm(state => state.actions);
  const {
    send
  } = useLlmView(state => state.actions);
  const onTellMeMore = event => __awaiter(void 0, void 0, void 0, function* () {
    const prompt = `${label('llm.tellMeMoreAbout')} ${item.title}`;
    yield send(prompt, response => {
      // console.log('Prompt.onChunk', response.chunks);
    }, response => {
      // console.log('Prompt.onEnd', response);
    });
  });
  const onGoToWebsite = event => __awaiter(void 0, void 0, void 0, function* () {
    if (isBrowser) {
      event.preventDefault();
      const url = yield decorateUrl(item, item.url);
      window.open(url, '_blank');
    }
  });
  const classNames = getClassNames('llm__event', {
    [`llm__event--${item.type}`]: !!item.type
  });
  return jsx("div", {
    className: classNames,
    children: jsxs("div", {
      className: "llm__event-inner",
      children: [jsxs("div", {
        className: "llm__event-content",
        children: [item.type == 'event' && jsx("div", {
          className: "llm__event-pretitle",
          children: label('llm.eventPretitle')
        }), item.title && jsx("div", {
          className: "llm__event-title",
          dangerouslySetInnerHTML: {
            __html: item.title
          }
        }), item.abstract && jsx("div", {
          className: "llm__event-body",
          dangerouslySetInnerHTML: {
            __html: item.abstract
          }
        }), item.place && jsxs("div", {
          className: "llm__event-location",
          children: [jsx(IconLlmPin, {}), " ", item.place]
        }), jsxs("div", {
          className: "llm__event-ctas",
          children: [jsx(Cta, {
            type: "button",
            label: label('llm.tellMeMore'),
            onClick: onTellMeMore
          }), jsx(Cta, {
            type: "text",
            label: label('llm.goToWebsite'),
            onClick: onGoToWebsite
          })]
        })]
      }), item.image && jsxs("div", {
        className: "llm__event-media",
        children: [jsx("div", {
          className: "llm__event-asset",
          children: jsx("img", {
            src: item.image,
            alt: ""
          })
        }), (item.time || item.date) && jsxs("div", {
          className: "llm__event-tags",
          children: [item.date && jsx("div", {
            className: "llm__event-tag llm__event-date",
            children: item.date
          }), item.time && jsx("div", {
            className: "llm__event-tag llm__event-time",
            children: item.time
          })]
        })]
      })]
    })
  });
};

export { Event };
//# sourceMappingURL=event.js.map
